/*
 * Copyright (c) Siemens AG 2018 ALL RIGHTS RESERVED.
 *
 * Digital Lifecycle Service (DLS)
 */

import React from 'react';
export default class ContentComponent extends React.Component {
  /**
   * Everytime the component will be updated, the script part of the loaded
   * html page will be executed. At creation time there is only a static text
   * so the execution will only happen with real html data which will always
   * be an update of the component.
   */
  componentDidUpdate(prevProps) {
    if (prevProps.selectedUrl !== this.props.selectedUrl) {
      this.executeScript();
    }
  }

  /**
   * Execute script after loading third party html
   */
  executeScript() {
    if (
      this.props.content.__html &&
      document
        .getElementById('dls-ap-content')
        .getElementsByTagName('script')[0]
    ) {
      const script = document
        .getElementById('dls-ap-content')
        .getElementsByTagName('script')[0].innerHTML;

      window.eval(script);
    }
  }

  render() {
    return (
      <div>
        {this.props.menuDesc && (
          <div id="dls-ap-description" className="dls-ap-decription-top">
            {this.props.menuDesc}
          </div>
        )}
        <div
          id="dls-ap-content"
          className="dls-ap-padding-top"
          dangerouslySetInnerHTML={this.props.content}
        />
      </div>
    );
  }
}
